import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface DeactivateIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function DeactivateIcon({ className, ...props }: DeactivateIconProps) {
  return (
    <svg
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-5', className)}
      {...props}
    >
      <path d="M7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5C0 3.35786 3.35786 0 7.5 0ZM7.5 1.60742C4.24546 1.60742 1.60742 4.24546 1.60742 7.5C1.60742 10.7545 4.24546 13.3926 7.5 13.3926C10.7545 13.3926 13.3926 10.7545 13.3926 7.5C13.3926 4.24546 10.7545 1.60742 7.5 1.60742ZM10.7412 6.85742C11.1108 6.8575 11.4109 7.15678 11.4111 7.52637C11.4111 7.89615 11.111 8.19621 10.7412 8.19629H4.3125C3.94267 8.19629 3.64258 7.8962 3.64258 7.52637C3.64281 7.15673 3.94281 6.85742 4.3125 6.85742H10.7412Z" fill="currentColor" />
    </svg>
  );
}
